export default __webpack_public_path__ + "static/media/kminn.12580c0f.png";